export default "__VITE_ASSET__Clww7ZHx__"